// import jsPDF from 'jspdf';

// export const convertJpgToPdf = async (jpgUrl) => {
//     const imgData = await fetch(jpgUrl).then(r => r.blob());
//     const pdf = new jsPDF();
//     pdf.addImage(URL.createObjectURL(imgData), 'JPEG', 0, 0);
//     return pdf.output('blob');
// }

import jsPDF from "jspdf";

// Funzione migliorata per convertire JPG in PDF con dimensioni corrette
export const convertJpgToPdf = async (jpgUrl) => {
  try {
    const imgData = await fetch(jpgUrl).then((r) => r.blob());
    const img = new Image();

    return new Promise((resolve, reject) => {
      img.onload = () => {
        const pdf = new jsPDF();

        // Ottieni dimensioni della pagina PDF (in mm)
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Ottieni dimensioni originali dell'immagine
        const imgWidth = img.width;
        const imgHeight = img.height;

        // Calcola il rapporto di scala per mantenere le proporzioni
        const widthRatio = pageWidth / imgWidth;
        const heightRatio = pageHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);

        // Calcola nuove dimensioni scalate
        const scaledWidth = imgWidth * ratio;
        const scaledHeight = imgHeight * ratio;

        // Centra l'immagine nella pagina
        const x = (pageWidth - scaledWidth) / 2;
        const y = (pageHeight - scaledHeight) / 2;

        // Aggiungi l'immagine con le dimensioni corrette
        pdf.addImage(
          URL.createObjectURL(imgData),
          "JPEG",
          x,
          y,
          scaledWidth,
          scaledHeight
        );

        resolve(pdf.output("blob"));
      };

      img.onerror = () => {
        reject(new Error("Errore nel caricamento dell'immagine"));
      };

      img.src = URL.createObjectURL(imgData);
    });
  } catch (error) {
    console.error("Errore nella conversione JPG to PDF:", error);
    return null;
  }
};

// Versione alternativa con orientamento automatico
export const convertJpgToPdfAutoOrientation = async (jpgUrl) => {
  try {
    const imgData = await fetch(jpgUrl).then((r) => r.blob());
    const img = new Image();

    return new Promise((resolve, reject) => {
      img.onload = () => {
        const imgWidth = img.width;
        const imgHeight = img.height;

        // Determina l'orientamento dell'immagine
        const isLandscape = imgWidth > imgHeight;

        // Crea PDF con orientamento appropriato
        const pdf = new jsPDF({
          orientation: isLandscape ? "landscape" : "portrait",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Calcola dimensioni per riempire la pagina mantenendo le proporzioni
        const widthRatio = pageWidth / imgWidth;
        const heightRatio = pageHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);

        const scaledWidth = imgWidth * ratio;
        const scaledHeight = imgHeight * ratio;

        // Centra l'immagine
        const x = (pageWidth - scaledWidth) / 2;
        const y = (pageHeight - scaledHeight) / 2;

        pdf.addImage(
          URL.createObjectURL(imgData),
          "JPEG",
          x,
          y,
          scaledWidth,
          scaledHeight
        );

        resolve(pdf.output("blob"));
      };

      img.onerror = () => {
        reject(new Error("Errore nel caricamento dell'immagine"));
      };

      img.src = URL.createObjectURL(imgData);
    });
  } catch (error) {
    console.error("Errore nella conversione JPG to PDF:", error);
    return null;
  }
};
